import React from 'react';
import PropTypes from 'prop-types';
import {
  KeyboardAvoidingView,
  View,
} from 'react-native';
import {
  Button, Input, Text, ButtonGroup,
} from 'react-native-elements';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import cc from 'currency-codes';

import Breadcrumb from '../../../../vendor/react-native-breadcrumb';
import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import stylesPublisher from '../../../styles/create';
import {
  appPriceValidation,
} from '../../../modules/validation/App';
import App from '../../../modules/data/App';
import { country } from '../../../localization';
import payoutMethods from '../../../modules/payout';
import { currency } from '../../../money';

const validationSchema = yupObject().shape({
  buyPrice: appPriceValidation,
  rentPrice: appPriceValidation,
});

class PublisherAppFormFinancial extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleCancel = this.handleCancel.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleNext = this.handleNext.bind(this);

    const { app } = this.props;

    const { type, importedFrom } = app.data;
    let { currency: appCurrency } = app.data;

    if (!appCurrency) {
      appCurrency = currency;
    }

    let payoutAvailable = false;
    Object.keys(payoutMethods).forEach((methodName) => {
      const method = payoutMethods[methodName];
      if (method.available && method.available(country, appCurrency)) {
        payoutAvailable = true;
      }
    });

    this.state = {
      type: type || 0, // FIXME(clairbee): keep it in props only
      freeOnly: !payoutAvailable,
      imported: !!importedFrom,
    };
  }

  // componentDidMount() {
  //   const { app } = this.props;
  // }

  handleCancel() {
    const { onCancel } = this.props;

    onCancel();
  }

  handleBack(values) {
    const { onSave, onPageSwitch } = this.props;

    onSave(values);
    onPageSwitch(3);
  }

  async handleNext(values, formikBag) {
    const {
      onSave,
      onPageSwitch,
      getAnalyticsService,
    } = this.props;
    const {
      type,
    } = this.state;

    formikBag.setSubmitting(true);
    const err = await onSave(values);
    if (err !== null) {
      getAnalyticsService().report.event('page4SaveError', 'create');
      formikBag.setStatus(err);
    } else {
      getAnalyticsService().report.event(`page4SaveSuccess${type}`, 'create');
    }
    formikBag.setSubmitting(false);

    if (err === null) {
      onPageSwitch(5);
    }
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    status,
  }) => {
    const buttons = [
      translate('app_free'),
      translate('app_rent_only'),
      translate('app_buy_only'),
      translate('app_rent_or_buy'),
    ];
    const { onPageSwitch, direction } = this.props;
    const { type, freeOnly, imported } = this.state;

    return (
      <>
        <Breadcrumb
          entities={[
            translate('create_app_app'),
            translate('create_app_guide'),
            translate('create_app_endpoints'),
            translate('create_app_payment'),
            translate('create_app_links'),
            translate('create_app_review'),
          ]}
          isTouchable
          flowDepth={3}
          onCrumbPress={(index) => onPageSwitch(index + 1)}
          borderRadius={3}
          firstCrumbStyle={stylesPublisher.publisherAppEdit.firstCrumbStyle}
          crumbsContainerStyle={direction === 'column' ? stylesPublisher.publisherAppEdit.crumbsContainerStyle : stylesPublisher.publisherAppEdit.crumbsContainerStyleLandscape}
        />
        {/* Page 4: Financials */}
        <KeyboardAvoidingView
          style={[
            styles.view.form,
            {
              backgroundColor: 'white',
              width: '100%',
              padding: 0,
              margin: 0,
              alignItems: 'center',
              justifyContent: 'space-evenly',
            },
          ]}
          behavior="padding"
        >
          <KeyboardAwareScrollView
            style={{
              flex: 1,
              width: '100%',
              maxWidth: 600,
              alignSelf: 'center',
              margin: 0,
            }}
            contentContainerStyle={{
              width: '100%',
              padding: 0,
              alignItems: 'center',
              justifyContent: 'space-evenly',
              paddingBottom: 20,
            }}
            enableAutomaticScroll={false}
          >
            {status !== undefined && (
              <Text
                style={{
                  color: 'red',
                }}
              >
                {status}
              </Text>
            )}

            {imported && (
              <Text
                style={{
                  width: '80%',
                  marginVertical: 10,
                  textAlign: 'center',
                  color: 'red',
                }}
              >
                {translate('app_free_imported')}
              </Text>
            )}

            {freeOnly && !imported && (
              <Text
                style={{
                  width: '80%',
                  marginVertical: 10,
                  textAlign: 'center',
                  color: 'red',
                }}
              >
                {translate('app_free_only')}
              </Text>
            )}

            <View
              style={{
                paddingHorizontal: 10,
                width: '100%',
                flexDirection: 'row',
              }}
            >
              <View
                style={{
                  flex: 1,
                  flexDirection: 'row',
                }}
              >
                <ButtonGroup
                  {...((freeOnly || imported) && { // eslint-disable-line react/jsx-props-no-spreading
                    disabled: true,
                  })}
                  onPress={(t) => {
                    this.setState({ type: t });
                    setFieldValue('type', t);
                  }}
                  selectedIndex={type}
                  buttons={buttons}
                  innerBorderStyle={{
                    width: 0,
                  }}
                  containerStyle={{
                    flex: 1,
                    borderWidth: 0,
                  }}
                  selectedButtonStyle={{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                  }}
                  selectedTextStyle={{
                    fontFamily: styles.primaryFont700,
                    fontWeight: '700',
                    fontSize: 14,
                    lineHeight: 14,
                    color: 'white',
                    backgroundColor: '#1FB578',
                    textAlign: 'center',
                    borderRadius: 30,
                    paddingHorizontal: 20,
                    paddingVertical: 4,
                  }}
                  disabledSelectedTextStyle={{
                    fontFamily: styles.primaryFont700,
                    fontWeight: '700',
                    fontSize: 14,
                    lineHeight: 14,
                    textAlign: 'center',
                  }}
                  buttonStyle={{
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                  }}
                  textStyle={{
                    fontFamily: styles.primaryFont400,
                    fontWeight: '400',
                    fontSize: 14,
                    lineHeight: 14,
                    color: 'black',
                    backgroundColor: 'transparent',
                    textAlign: 'center',
                    borderRadius: 30,
                    paddingHorizontal: 20,
                    paddingVertical: 4,
                  }}
                  disabledTextStyle={{
                    fontFamily: styles.primaryFont400,
                    fontWeight: '400',
                    fontSize: 14,
                    lineHeight: 14,
                    color: 'black',
                    backgroundColor: 'transparent',
                    textAlign: 'center',
                  }}
                />
              </View>
            </View>
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={[
                styles.form.inputLabel,
                { color: 'grey' },
              ]}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.currency && errors.currency ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              disabled
              editable={false}
              label={translate('app_price_currency')}
              value={`${cc.code(values.currency).currency} (${values.currency})`}
              autoCapitalize="none"
              onChangeText={(_value) => { }}
              onBlur={() => { }}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={[
                styles.form.inputLabel,
                { color: (type % 2) === 1 ? 'black' : 'grey' },
              ]}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.rentPrice && errors.rentPrice ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              disabled={(type % 2) !== 1}
              editable={(type % 2) === 1}
              label={translate('app_rent_price')}
              keyboardType="numeric"
              value={type % 2 === 1 && values.rentPrice ? values.rentPrice.toString() : ''}
              placeholder={(type % 2) === 1 ? translate('app_eg', { example: '1.0' }) : translate('app_na')}
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('rentPrice', value)}
              onBlur={() => setFieldTouched('rentPrice')}
              errorMessage={touched.rentPrice && errors.rentPrice ? errors.rentPrice : undefined}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={[
                styles.form.inputLabel,
                { color: (type % 2) === 1 ? 'black' : 'grey' },
              ]}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.rentDays && errors.rentDays ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              disabled={(type % 2) !== 1}
              editable={(type % 2) === 1}
              label={translate('app_rent_period')}
              keyboardType="numeric"
              value={type % 2 === 1 && values.rentDays ? values.rentDays.toString() : ''}
              placeholder={type % 2 === 1 ? translate('app_eg', { example: '90' }) : translate('app_na')}
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('rentDays', value)}
              onBlur={() => setFieldTouched('rentDays')}
              errorMessage={touched.rentDays && errors.rentDays ? errors.rentDays : undefined}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={[
                styles.form.inputLabel,
                { color: type > 1 ? 'black' : 'grey' },
              ]}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.buyPrice && errors.buyPrice ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              disabled={type <= 1}
              editable={type > 1}
              label={translate('app_buy_price')}
              keyboardType="numeric"
              value={type > 1 && values.buyPrice ? values.buyPrice.toString() : ''}
              placeholder={type > 1 ? translate('app_eg', { example: '3.0' }) : translate('app_na')}
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('buyPrice', value)}
              onBlur={() => setFieldTouched('buyPrice')}
              errorMessage={touched.buyPrice && errors.buyPrice ? errors.buyPrice : undefined}
            />
          </KeyboardAwareScrollView>
        </KeyboardAvoidingView>
        <View style={styles.form.containerButtons}>
          <Button
            title={translate('button_cancel')}
            containerStyle={styles.button.secondaryContainer}
            buttonStyle={styles.button.secondary}
            disabledStyle={styles.button.secondaryDisabled}
            titleStyle={styles.button.secondaryTitle}
            disabledTitleStyle={styles.button.secondaryTitleDisabled}
            onPress={this.handleCancel}
          />
          <Button
            title={translate('button_prev')}
            containerStyle={styles.button.primaryContainer}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={() => this.handleBack(values)}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
          <Button
            title={translate('button_next')}
            containerStyle={styles.button.primaryContainer}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
        </View>
      </>
    );
  };

  render() {
    const { app } = this.props;

    const initialValues = {
      type: app.data.type,
      rentDays: app.data.rentDays,
      rentPrice: app.data.rentPrice,
      buyPrice: app.data.buyPrice,
      currency: app.data.currency || currency,
    };

    return (
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikBag) => this.handleNext(values, formikBag)}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

PublisherAppFormFinancial.defaultProps = {
};

PublisherAppFormFinancial.propTypes = {
  app: PropTypes.instanceOf(App).isRequired,
  onCancel: PropTypes.func.isRequired,
  onPageSwitch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
};

export default PublisherAppFormFinancial;
